import { useNavigate } from 'react-router-dom';

/**
 * "Case Studies Page" admin tab: a singleton listing page, so this tab is
 * just an index card linking to the dedicated full-viewport WYSIWYG route
 * (see ../CaseStudiesPageEditor.jsx), which also embeds the existing
 * CaseStudiesEditor/TestimonialsEditor panels for cards/categories/stats/
 * detail-pages/testimonial items — full CRUD, nothing editable only
 * elsewhere.
 */
export default function CaseStudiesPageTab() {
  const navigate = useNavigate();

  return (
    <div className="admin-panel">
      <div className="admin-panel__head">
        <div>
          <h2>Case Studies Page</h2>
          <p className="admin-panel__desc">
            The fully inline-editable <strong>/case-studies</strong> listing page (hero, "proof" section intro,
            bottom CTA banner) — plus the card grid, categories, stats, and testimonials, all embedded here with
            full add/edit/remove. Use <strong>Edit</strong> for on-page WYSIWYG editing.
          </p>
        </div>
      </div>

      <div className="admin-list">
        <div className="admin-list-item">
          <div>
            <strong>Case Studies</strong>
            <br />
            <a href="/case-studies" target="_blank" rel="noopener noreferrer">
              /case-studies
            </a>
          </div>
          <div className="admin-list-actions">
            <button
              type="button"
              className="admin-btn admin-btn--ghost admin-btn--sm"
              onClick={() => navigate('/admin/case-studies-page/edit')}
            >
              Edit
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
